// extracted by mini-css-extract-plugin
export var sliderRange = "_r8-2";
export var sliderRoot = "_r8-0";
export var sliderThumb = "_r8-3";
export var sliderTrack = "_r8-1";